import type { HeroProps } from '@/components/lemonadeGoesGlobal/Hero';
import { sharedConfig } from '@/pageConfig/shared';
import og from '@/static/assets/lemonade_goes_global/og.png';
import { DocumentTypes } from 'contentlayer/generated';
import content from '../../../../.contentlayer/generated/LemonadeGoesGlobal/lemonadeGoesGlobal__en-FR.mdx.json';
import type { BasePageConfig } from '../../BasePageConfig';

export interface Config extends BasePageConfig {
  hero: HeroProps;
}

export const config: Config = {
  layout: { ...sharedConfig['en-FR'].layout, showAskUsAnything: true },
  seo: {
    title: 'Where in the US and Europe is Lemonade available?',
    metaTitle: 'Where in the US and Europe is Lemonade available?',
    description: 'Find out where Lemonade is bringing home insurance powered by tech and driven by social good ✨',
    ogImage: og.src,
  },
  hero: {
    title: 'Be the First to Know!',
    subtitle: `We’re rolling out across the <a href="https://www.lemonade.com/blog/lemonade-expansion-united-states/"> US </a> and Europe.\nLeave your email and we’ll let you know when we’re headed your way`,
  },
  MDXContent: content as DocumentTypes,
};
